import Modal from "react-responsive-modal";
import { New } from "../../types";
import { useEffect, useState } from "react";
import moment from "moment";
import { api } from "../services/api";

type EditNewProps = {
    value: null | New;
    onChange: (value: New) => void;
    onClose: () => void;
};

const emptyNew: New = {
    _id: "",
    title: "",
    date: moment().format("YYYY-MM-DD"),
    content: "",
};

export default function EditNew({ value, onChange, onClose }: EditNewProps) {
    const [newNews, setNewNews] = useState<New>(value ?? emptyNew);
    const [message, setMessage] = useState("");

    useEffect(() => {
        setNewNews(value ?? emptyNew);
        setMessage("");
    }, [value]);

    async function handleSave() {
        setMessage("Ukládám...");

        if (newNews._id === "") {
            const [, error] = await api.addNews(newNews);
            if (error) {
                setMessage("Přidání aktuality selhalo");
                return;
            }
            setMessage("Aktualita přidána");
        } else {
            const [, error] = await api.updateNews(newNews);
            if (error) {
                setMessage("Ukládání změn selhalo");
                return;
            }
            setMessage("Aktualita úspěšně uložena");
        }

        onChange(newNews);
    }

    return (
        <Modal
            open={value !== null}
            onClose={onClose}
            center
            styles={{ modal: { width: "550px" } }}
        >
            <h2>
                {newNews._id === "" ? "Nová aktualita" : "Upravit aktualitu"}
            </h2>
            {message && <p className="alert">{message}</p>}
            {value && (
                <>
                    <input
                        type="text"
                        placeholder="Titulek"
                        value={newNews.title}
                        onChange={(e) =>
                            setNewNews({
                                ...newNews,
                                title: e.target.value,
                            })}
                    />
                    <input
                        type="date"
                        placeholder="Datum vystavení"
                        value={newNews.date}
                        onChange={(e) =>
                            setNewNews({
                                ...newNews,
                                date: moment(
                                    e.target.value,
                                ).format("YYYY-MM-DD"),
                            })}
                    />
                    <textarea
                        style={{ minHeight: "250px" }}
                        placeholder="Obsah"
                        onChange={(e) =>
                            setNewNews({
                                ...newNews,
                                content: e.target.value,
                            })}
                    >
                        {newNews.content}
                    </textarea>
                    <button onClick={handleSave}>
                        {newNews._id === ""
                            ? "Přidat aktualitu"
                            : "Uložit změny"}
                    </button>
                </>
            )}
        </Modal>
    );
}
